import React, { useState } from "react";
import { FaWallet, FaExclamationTriangle, FaPhoneAlt, FaSms, FaTimes, FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const WalletLowBalanceAlert = ({ healthData, loading }) => {
  const [dismissed, setDismissed] = useState(false);

  if (loading || !healthData || dismissed) return null;

  const {
    wallet_balance,
    is_low_balance,
    has_upcoming_services,
    upcoming_voice_call_events,
    upcoming_sms_events,
  } = healthData;

  if (!is_low_balance || !has_upcoming_services) return null;

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #fff7ed 0%, #fef2f2 50%, #fff7ed 100%)",
        border: "1.5px solid rgba(239,68,68,0.3)",
        boxShadow: "0 4px 20px rgba(239,68,68,0.1), 0 2px 8px rgba(0,0,0,0.04)",
      }}
      className="rounded-2xl p-4 mb-4 relative overflow-hidden"
    >
      {/* Top accent line */}
      <div
        style={{
          background: "linear-gradient(90deg, #ef4444, #f59e0b, #ef4444)",
        }}
        className="h-0.5 w-full absolute top-0 left-0"
      />

      <div className="flex items-start gap-3">
        {/* Icon */}
        <div
          style={{
            background: "rgba(239,68,68,0.12)",
            border: "1px solid rgba(239,68,68,0.25)",
          }}
          className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center"
        >
          <FaExclamationTriangle className="text-red-500 text-lg" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="text-sm font-black text-red-700 tracking-wide">
              Low Wallet Balance Alert
            </h4>
          </div>

          <p className="text-xs font-semibold text-gray-600 mb-3 leading-relaxed">
            Your wallet balance is <span className="text-red-600 font-black">₹{wallet_balance}</span>. 
            {upcoming_voice_call_events > 0 && (
              <span>You have <span className="text-red-600 font-black">{upcoming_voice_call_events} voice call{upcoming_voice_call_events > 1 ? "s" : ""}</span>{upcoming_sms_events > 0 ? " and " : " "}</span>
            )}
            {upcoming_sms_events > 0 && (
              <span><span className="text-amber-600 font-black">{upcoming_sms_events} SMS service{upcoming_sms_events > 1 ? "s" : ""}</span> </span>
            )}
            scheduled. Please recharge your wallet to avoid service interruption.
          </p>

          {/* Service breakdown icons with counts */}
          <div className="flex flex-wrap gap-2 mb-3">
            {upcoming_voice_call_events > 0 && (
              <span
                style={{
                  background: "rgba(239,68,68,0.08)",
                  border: "1px solid rgba(239,68,68,0.2)",
                }}
                className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full text-red-700"
              >
                <FaPhoneAlt className="text-red-500 text-[10px]" />
                {upcoming_voice_call_events} Voice Call{upcoming_voice_call_events > 1 ? "s" : ""}
              </span>
            )}
            {upcoming_sms_events > 0 && (
              <span
                style={{
                  background: "rgba(245,158,11,0.08)",
                  border: "1px solid rgba(245,158,11,0.2)",
                }}
                className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full text-amber-700"
              >
                <FaSms className="text-amber-500 text-[10px]" />
                {upcoming_sms_events} SMS Service{upcoming_sms_events > 1 ? "s" : ""}
              </span>
            )}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2">
            <Link
              to="/dashboard/wallet"
              style={{
                background: "linear-gradient(135deg, #dc2626, #b91c1c)",
                boxShadow: "0 2px 8px rgba(220,38,38,0.3)",
              }}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-white text-xs font-black transition-all hover:opacity-90 active:scale-95 no-underline"
            >
              <FaWallet className="text-[10px]" />
              Recharge Wallet
              <FaExternalLinkAlt className="text-[9px]" />
            </Link>
            <button
              onClick={() => setDismissed(true)}
              className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-gray-500 text-xs font-semibold border border-gray-200 bg-white hover:bg-gray-50 transition-all active:scale-95"
            >
              <FaTimes className="text-[10px]" />
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletLowBalanceAlert;